export default function createFeatureCollection(data) {
    if (!data || !Array.isArray(data)) return '';

    const collectionPoint = data?.map(item => {
        return {
            type: 'Feature',
            properties: {},
            geometry: {
                type: 'Point',
                coordinates: item.coordinates,
            },
        };
    });

    const collectionLine = {
        type: 'Feature',
        properties: {
            items: data,
        },
        geometry: {
            type: 'LineString',
            coordinates: data?.map(item => [item.lon, item.lat]),
        },
    };
    return {
        type: 'FeatureCollection',
        features: [collectionLine],
    };
}
